import TimeChart from './timeChart/timeChart.js';

export default angular.module('eventix.dashboard.components.charts', [
    TimeChart
]).name;
